import $ from 'jquery';

/**
 * Used to attach to a element to always watch if its in the viewport.
 *
 * When scrolling, if element is in viewport add a parameter, a data attribute and a class name.
 */
export class InViewport {
	_element;

	constructor( element ) {
		this.element = $( element );

		if ( this.element.length ) {
			this.scroll();
		}
	}

	scroll() {
		$( window ).scroll( () => {
			const inViewport = this.inViewport();
			this.element.inViewport = inViewport;
			this.element.attr( 'data-in-viewport', inViewport ).toggleClass( 'in-viewport', inViewport );
		} );
	}

	inViewport() {
		return this.elementBottom() > this.viewportTop() && this.elementTop() < this.viewportBottom();
	}

	elementBottom() {
		return this.elementTop() + this.element.outerHeight();
	}

	viewportTop() {
		return $( window ).scrollTop();
	}

	elementTop() {
		return this.element.offset().top;
	}

	viewportBottom() {
		return this.viewportTop() + $( window ).height();
	}

	/** ------------------------------------------------------------------------------------------
	 * Setters.
	 * ------------------------------------------------------------------------------------------ */

	set element( value ) {
		this._element = value;
	}

	/** ------------------------------------------------------------------------------------------
	 * Getters.
	 * ------------------------------------------------------------------------------------------ */

	get element() {
		return this._element;
	}
}
